import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderListController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderListController.php
* @route '/api/fetch-supplier-orders'
*/
const GetSupplierOrderListController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetSupplierOrderListController.url(options),
    method: 'post',
})

GetSupplierOrderListController.definition = {
    methods: ["post"],
    url: '/api/fetch-supplier-orders',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderListController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderListController.php
* @route '/api/fetch-supplier-orders'
*/
GetSupplierOrderListController.url = (options?: RouteQueryOptions) => {
    return GetSupplierOrderListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderListController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderListController.php
* @route '/api/fetch-supplier-orders'
*/
GetSupplierOrderListController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetSupplierOrderListController.url(options),
    method: 'post',
})

export default GetSupplierOrderListController